var map = {
	"./ORGANIZATION_AREA_INDICATORS_Configurator.js": [
		84999,
		999
	],
	"./ORGANIZATION_AUE_PIECHART_Configurator.js": [
		43625,
		255
	],
	"./ORGANIZATION_LOGO_NAME_Configurator.js": [
		260,
		260
	],
	"./ORGANIZATION_SDGS_PIECHART_Configurator.js": [
		60945,
		945
	],
	"./WIDGT-AIND-QUANT-01_Configurator.js": [
		97095,
		95
	],
	"./WIDGT-AIND-QUANT-02_Configurator.js": [
		15859,
		859
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94898;
module.exports = webpackAsyncContext;